export const name = 'orgImageController';

export default function orgImageController(
  $mdDialog,
  $mdToast,
  $gzAnalytics,
  $q,
  $scope,
  $translate,
  $timeout,
  rnClient,
  rnHttp,
  rnOrganization,
  Upload,
  $window
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Constants
  const PORTAL_SERVICE_NAME = 'portal_service';
  const PORTAL_ORG_IMAGE_API_PATH = 'organization/profile/image';

  // View Model
  let vm = this;

  //   VM properties
  vm.isLoading = true;
  vm.sending = false;
  vm.errorKey = null;
  vm.currentProfileImageSrc = null;
  vm.inputFile = null;
  vm.editing = false;
  vm.useDefaultImage = false;
  vm.image = {
    src: null,
    cropped: null
  };

  //   VM methods
  vm.activate = activate;
  vm.updateOrDeleteImage = updateOrDeleteImage;
  vm.useDefault = useDefault;
  vm.disableSubmit = disableSubmit;
  vm.close = close;
  vm.cancel =cancel;
  vm.validateFile = validateFile;

  vm.activate = activate;
  activate();

  //////////////

  function activate() {
    // roughly 2.5 aspect ratio to be consistent with Home card
    vm.options = {
      boundary: {width: 575, height: 245},
      enforceBoundary: false,
      viewport: {
        width: 555,
        height: 225,
        type: 'square'
      }
    };

    let promises = [];
    promises.push(getCurrentProfileImageFromServer());
    promises.push(getOrganizationData());
    return $q.all(promises)
      .catch((error) => {
        vm.errorKey = 'uxf.uxf.Error_UnableToGetData';
      })
      .finally(() => {
        vm.isLoading = false;
      });
  }

  function getCurrentProfileImageFromServer(cache = true) {
    vm.isLoading = true;
    vm.useDefaultImage = false;

    return $window.$printos.v1.client.getConfigAsync().then(cc => {
      $timeout(() => {
        vm.currentProfileImageSrc = _.get(cc, 'context.image', null);
        if (!vm.currentProfileImageSrc) {
          vm.useDefaultImage = true;
        }
      });
    })
      .catch(() => {
        // No profile has yet been set up
        vm.useDefaultImage = true;
      });
  }

  function getOrganizationData() {
    return rnOrganization.getOrganization().then(response => {
      vm.account = response.data;
    });
  }

  function validateFile(file) {
    if (!file) {
      return;
    }
    vm.errorKey = null;
    readFile(file)
      .then(src => {
        return testImageSource(src)
          .then(() => {
            vm.editing = true;
            vm.image.src = src;
          });
      })
      .catch(error => {
        vm.editing = false;
        vm.inputFile = null;
        vm.errorKey = 'uxf.uxf.ChangeProfileImage_FileError';
      });
  }

  function readFile(file) {
    return $q((resolve, reject) => {
      let reader = new $window.FileReader();
      reader.onloadend = e => {
        let url = e.target.result;
        let error = e.target.error;
        if (error != null) {
          reject('Error reading file: ' + error);
        }
        else {
          resolve(url);
        }
      };
      reader.readAsDataURL(file);
    });
  }

  function testImageSource(url) {
    // Catch error before binding invalid file to croppie
    // Adapted from https://stackoverflow.com/questions/9809015/image-onerror-event-never-fires-but-image-isnt-valid-data-need-a-work-around
    return $q((resolve, reject) => {
      let image = new $window.Image();
      image.onload = function() {
        if (_.get(this, 'naturalHeight')) {
          if (this.naturalHeight + this.naturalWidth === 0) {
            this.onerror();
          }
        }
        else if (this.width + this.height === 0) {
          this.onerror();
        }
        resolve(image.src);
      };
      image.onerror = () => {
        reject('Error: invalid image source');
      };
      image.src = url;
    });
  }

  function updateOrDeleteImage() {
    if (_.get(vm, 'image.cropped')) {
      updateImage();
    }
    else {
      deleteImage();
    }
  }

  function updateImage() {
    let image = vm.image.cropped;
    vm.sending = true;
    vm.errorKey = null;

    return sendFileToPortal(image).then(response => {
      let orgId = _.get(response, 'data.organizationId');
      $gzAnalytics.eventSave('org profile image changed',
        {label: 'org id: ' + orgId});
      vm.errorKey = null;
      $mdToast.showSimple($translate.instant('uxf.uxf.ChangeOrgProfileImage_Updated'));
      close();
    })
      .catch(error => {
        ga('send', 'exception', {
          exDescription: 'org profile image changed failed: ' + _.get(error, 'smsError.message', 'unknown')
        });
        vm.errorKey = 'uxf.uxf.GenericError';
      })
      .finally(() => {
        vm.sending = false;
      });
  }

  function sendFileToPortal(file) {
    let fd = new $window.FormData();
    fd.append('file', file);
    let config = {version: 2, transformRequest: angular.identity, headers: {'Content-Type': undefined}, rhino: {allowUndefinedContentType: true}};
    return rnHttp.post(PORTAL_SERVICE_NAME, PORTAL_ORG_IMAGE_API_PATH, fd, config);
  }

  function useDefault($event) {
    $event.stopPropagation();
    vm.useDefaultImage = true;
  }

  function deleteImage() {
    vm.sending = true;
    vm.errorKey = null;

    let config = {version: 2};
    return rnHttp.delete(PORTAL_SERVICE_NAME, PORTAL_ORG_IMAGE_API_PATH, config).then((response) => {
      let orgId = _.get(response, 'data.organizationId');
      $gzAnalytics.eventSave('org profile image reset',
        {label: 'org id: ' + orgId});
      vm.currentProfileImageSrc = null;
      vm.errorKey = null;
      $mdToast.showSimple($translate.instant('uxf.uxf.ChangeOrgProfileImage_ResetToDefault'));
      close();
    })
      .catch(error => {
        ga('send', 'exception', {
          exDescription: 'org profile image changed failed: ' + _.get(error, 'smsError.message', 'unknown')
        });
        vm.errorKey = 'uxf.uxf.GenericError';
      })
      .finally(() => {
        vm.sending = false;
      });
  }

  function disableSubmit() {
    return vm.sending === true || (vm.editing === false && vm.useDefaultImage === false);
  }

  function close() {
    $mdDialog.hide();
  }

  function cancel() {
    $mdDialog.cancel();
  }
}
